import { AppLink } from '@/routing';

interface NextLinkCompatProps extends Omit<React.ComponentProps<typeof AppLink>, 'href'> {
  href: string;
  prefetch?: boolean;
  replace?: boolean;
  scroll?: boolean;
}

export default function Link({
  href,
  prefetch: _prefetch,
  replace: _replace,
  scroll: _scroll,
  ...props
}: NextLinkCompatProps) {
  return <AppLink href={href} {...props} />;
}
